module.exports = __webpack_public_path__ + "img/play-button.5cb2a53d.svg";